import React from 'react'
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from 'reactstrap'

export default function ExportTable (
  {
    handleExport,
    type
  }) {
  return (
    <UncontrolledDropdown>
      <DropdownToggle
        caret
        color="danger"
        className="d-flex align-items-center"
      >
        <i className="ri-download-2-line me-2"></i>
          Export
      </DropdownToggle>

      <DropdownMenu end>
        {type !== 'details' &&
          <DropdownItem onClick={() => handleExport('csv')}>
            <i className="ri-file-excel-2-line me-2"></i>
              Export as CSV
          </DropdownItem>
        }
        <DropdownItem onClick={() => handleExport('pdf')}>
          <i className="ri-file-pdf-line me-2"></i>
            Export as PDF
        </DropdownItem>
      </DropdownMenu>
    </UncontrolledDropdown>
  )
}
